import { Clock, Mail, MapPin, MoveRight, Phone } from "lucide-react";
import { images } from "../assets/assets";
import { Link } from "react-router-dom";
import { FaYoutube } from "react-icons/fa";

const Footer = () => {
  const footerLinks = [
    { label: "About Us", path: "/about" },
    { label: "Services", path: "/services" },
    { label: "Doctors", path: "/doctors" },
    { label: "Appointment", path: "/appointment" },
    { label: "Contact", path: "/contact" },
    { label: "Blog", path: "/blog" },
  ];
  return (
    <>
      <div
        className="bg-[#001B45] grid grid-cols-1 md:grid-cols-2
       lg:grid-cols-3 gap-8  justify-items-center py-10 px-6"
      >
        {/* Brand */}
        <div>
          <div className="flex flex-wrap sm:flex-nowrap items-start gap-4 justify-center md:justify-start">
            <div className="flex flex-col gap-8 items-center">
              <img
                src={images.Logo}
                alt="logo"
                className="w-[90px] h-[90px] md:w-[115px] md:h-[115px]"
              />
              <div className="flex gap-2 items-center">
                <a
                  href="https://www.instagram.com/devrishi_hospital/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-75 active:opacity-50 hover:scale-110 transition-all"
                >
                  <img
                    src={images.InstagramFooter}
                    alt="instagram"
                    className="w-[28px] h-[28px]"
                  />
                </a>
                <a
                  href="https://www.facebook.com/devrishihospital"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="hover:opacity-75 active:opacity-50 hover:scale-110 transition-all"
                >
                  <img
                    src={images.FaceBookFooter}
                    alt="facebook"
                    className="w-[28px] h-[28px]"
                  />
                </a>
                <a
                  href="https://www.youtube.com/@DevRishiHospital"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <FaYoutube className="w-6 h-6 p-0.5 bg-white rounded-md hover:text-red-600 transition-colors" />
                </a>
              </div>
            </div>
            <div className="max-w-[246px]">
              <p className="font-bold text-[20px] md:text-[25px] text-white leading-none">
                Dev Rishi Hospital
              </p>
              <p className="text-[#C0C0C0]  text-[13px] md:text-[14px] leading-[1.3] mt-1">
                is committed to providing high-quality, affordable healthcare
                with experienced doctors and modern facilities. We ensure
                compassionate care and patient satisfaction at every step.
              </p>
            </div>
          </div>
        </div>

        {/* Links */}
        <div className="flex flex-col gap-3 items-center md:items-start">
          {footerLinks.map((link, idx) => (
            <Link
              key={idx}
              to={link.path}
              className="text-[14px] md:text-base text-white flex items-center gap-1 hover:gap-1.5 hover:text-[#93C5FD] active:text-[#60A5FA] transition-all duration-150"
            >
              {link.label}
              <MoveRight color="currentColor" className="w-4 h-4" />
            </Link>
          ))}
        </div>

        {/* Contact */}
        <div className="flex flex-col gap-3 items-center md:items-start">
          <div className="flex gap-2 items-start">
            <MapPin color="#ffffff" className="w-5 h-5 mt-0.5 flex-shrink-0" />
            <p className="text-[13px] md:text-base text-white max-w-[200px]">
              3rd, KM Milestone Road, Sarsawa, Nakur Uttar Pradesh 247342
            </p>
          </div>
          <div className="flex gap-2 items-center">
            <Phone color="#ffffff" className="w-5 h-5 flex-shrink-0" />
            <a
              href="tel:+917300906444"
              className="text-[13px] md:text-base text-white hover:text-[#93C5FD] transition-colors"
            >
              +91 7300906444
            </a>
          </div>
          <div className="flex gap-2 items-center">
            <Mail color="#ffffff" className="w-5 h-5 flex-shrink-0" />
            <a
              href="mailto:hospitaldevrishi@gmail.com"
              className="text-[13px] md:text-base text-white hover:text-[#93C5FD] transition-colors break-all"
            >
              hospitaldevrishi@gmail.com
            </a>
          </div>
          <div className="flex gap-2 items-center">
            <Clock color="#ffffff" className="w-5 h-5 flex-shrink-0" />
            <p className="text-[13px] md:text-base text-white">Open 24×7</p>
          </div>
        </div>
      </div>

      {/* Copyright */}
      <div className="flex px-20 flex-row justify-between font-semibold bg-[#E8F1FF] py-3 ">
        <p className="text-[13px] md:text-base  text-center md:text-right">
          © 2026 Dev Rishi Hospital & Research Centre. All rights reserved.
        </p>
        <a
          href="https://dgtlinnovations.in/"
          target="_blank"
          rel="noopener noreferrer"
        >
          • Developed by Digital Innovations
        </a>
      </div>
    </>
  );
};

export default Footer;
